import React from 'react'
import { Button, makeStyles } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet-async'
import { useAuthentication } from '../authentication/AuthenticationProvider'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    maxWidth: theme.spacing(80),
  },
  ssoLogin: {
    alignSelf: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    maxWidth: theme.spacing(50),
  },
}))

export function LoginPage(): React.ReactElement {
  const classes = useStyles()
  const { login } = useAuthentication()
  const { t } = useTranslation()

  return (
    <div className={classes.container}>
      <Helmet title={t('login.title')} />

      <div className={classes.ssoLogin}>
        <Button
          variant="contained"
          color="primary"
          onClick={login}
          fullWidth
          data-testid="login-with-ssao-button"
        >
          {t('login.loginWithSso')}
        </Button>
      </div>
    </div>
  )
}
